import { useEffect, useMemo } from 'react'

import { useUser } from '@/client/context/user'
import { setPrimaryInterestCookie } from '@/client/services/primaryInterest/setPrimaryInterestCookie'
import type { PrimaryInterestV2 } from '@/client/services/primaryInterest/types'
import { type AuthMode, getAuthUrl } from '@/client/services/url'

import ShwLink, { type ShwLinkProps } from '@/components/ShwLink'

export default function AuthLink({
  mode = 'login',
  returnTo = null,
  children,
  primaryInterest,
  ...props
}: {
  mode?: AuthMode
  returnTo?: string | null
  children: React.ReactNode
  primaryInterest?: PrimaryInterestV2
} & Omit<ShwLinkProps, 'href'>): JSX.Element {
  const user = useUser()

  const authUrl = useMemo(() => getAuthUrl({ returnTo, user, mode }), [returnTo, user, mode])

  useEffect(() => {
    if (primaryInterest != null) {
      setPrimaryInterestCookie(primaryInterest)
    }
  }, [primaryInterest])

  return (
    <ShwLink
      href={authUrl}
      width={props.width ?? '100%'}
      display={props.display ?? 'inline'}
      {...props}
    >
      {children}
    </ShwLink>
  )
}
